var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map(p=>{return+p==p?+p:p})},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
const exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
const get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
const eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
const findLatestVersion = (scope, key, eager) => {
	const versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
const findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	const versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
const findSingletonVersionKey = (scope, key, eager) => {
	const versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
const getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
const getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	const versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
const fail = (msg) => {
	throw new Error(msg);
}
const failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
const warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
const init = (fn) => (function(scopeName, key, eager, c, d) {
	const promise = __webpack_require__.I(scopeName);
	if (promise?.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

const useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
const load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
const loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
const loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
const loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
const loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
const loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
const installedModules = {};
const moduleToHandlerMapping = {
	5194: () => (loadSingletonVersion("default", "vue", true, [1,3,0,0], () => (() => (__webpack_require__(6406))))),
	8328: () => (loadSingletonVersion("default", "vue", true, [1,3,2,0], () => (() => (__webpack_require__(6406))))),
	822: () => (loadSingletonVersion("default", "vue", true, [4,3,5,13], () => (() => (__webpack_require__(6406))))),
	4505: () => (loadSingletonVersion("default", "vue", true, [1,3,5,13], () => (() => (__webpack_require__(6406))))),
	6897: () => (loadSingletonVersion("default", "vue-i18n", true, [4,10,0,5], () => (() => (__webpack_require__(1005))))),
	4414: () => (loadSingletonVersion("default", "@dsc/federated-styles", false, [0], () => (__webpack_require__.e(3084).then(() => (() => (__webpack_require__(3084))))))),
	3602: () => (loadSingletonVersion("default", "@mcp/frontend-shared-domain-components", false, [0], () => (Promise.all([__webpack_require__.e(2826), __webpack_require__.e(785), __webpack_require__.e(8560), __webpack_require__.e(9130), __webpack_require__.e(3565), __webpack_require__.e(703), __webpack_require__.e(223)]).then(() => (() => (__webpack_require__(223))))))),
	5198: () => (loadSingletonVersion("default", "@mcp/shared", false, [1,1,119,1], () => (__webpack_require__.e(1118).then(() => (() => (__webpack_require__(818))))))),
	5314: () => (loadSingletonVersion("default", "@splunk/otel-web", false, [4,1,2,0], () => (__webpack_require__.e(4956).then(() => (() => (__webpack_require__(4956))))))),
	2432: () => (loadSingletonVersion("default", "@design-system/css", false, [4,29,3,1], () => (Promise.all([__webpack_require__.e(8868), __webpack_require__.e(5435)]).then(() => (() => (__webpack_require__(8868))))))),
	6423: () => (loadSingletonVersion("default", "@design-system/web-components/stamp-provider", false, [4,29,3,1], () => (__webpack_require__.e(2600).then(() => (() => (__webpack_require__(2600))))))),
	791: () => (loadSingletonVersion("default", "@design-system/web-components/select-field", false, [4,29,3,1], () => (__webpack_require__.e(7394).then(() => (() => (__webpack_require__(7394))))))),
	1841: () => (loadSingletonVersion("default", "@design-system/web-components/radio-field-group", false, [4,29,3,1], () => (__webpack_require__.e(6639).then(() => (() => (__webpack_require__(6639))))))),
	1875: () => (loadSingletonVersion("default", "@design-system/web-components/modal", false, [4,29,3,1], () => (__webpack_require__.e(8170).then(() => (() => (__webpack_require__(8170))))))),
	3629: () => (loadSingletonVersion("default", "@design-system/web-components/heading", false, [4,29,3,1], () => (__webpack_require__.e(7377).then(() => (() => (__webpack_require__(7377))))))),
	3685: () => (loadSingletonVersion("default", "@design-system/web-components/icon-button", false, [4,29,3,1], () => (__webpack_require__.e(8183).then(() => (() => (__webpack_require__(8183))))))),
	5073: () => (loadSingletonVersion("default", "@design-system/web-components/alert", false, [4,29,3,1], () => (__webpack_require__.e(9241).then(() => (() => (__webpack_require__(9241))))))),
	6663: () => (loadSingletonVersion("default", "@design-system/web-components/date-field", false, [4,29,3,1], () => (__webpack_require__.e(7910).then(() => (() => (__webpack_require__(7910))))))),
	6799: () => (loadSingletonVersion("default", "@design-system/web-components/checkbox-field", false, [4,29,3,1], () => (__webpack_require__.e(8847).then(() => (() => (__webpack_require__(8847))))))),
	7031: () => (loadSingletonVersion("default", "@design-system/web-components/button", false, [4,29,3,1], () => (__webpack_require__.e(3091).then(() => (() => (__webpack_require__(3091))))))),
	9487: () => (loadSingletonVersion("default", "@design-system/web-components/icon", false, [4,29,3,1], () => (__webpack_require__.e(7626).then(() => (() => (__webpack_require__(7626))))))),
	9847: () => (loadSingletonVersion("default", "@design-system/web-components/loader", false, [4,29,3,1], () => (__webpack_require__.e(7952).then(() => (() => (__webpack_require__(7952))))))),
	3037: () => (loadSingletonVersion("default", "vue", true, [1,3,3,0], () => (() => (__webpack_require__(6406))))),
	703: () => (loadSingletonVersion("default", "vue", true, [,[1,2,6,0],[1,3,0,0,,0],1], () => (() => (__webpack_require__(6406))))),
	2265: () => (loadSingletonVersion("default", "element-plus", false, [4,2,13,7], () => (Promise.all([__webpack_require__.e(1605), __webpack_require__.e(3199)]).then(() => (() => (__webpack_require__(1605))))))),
	2578: () => (loadSingletonVersion("default", "vue-i18n", true, [1,10,0,5], () => (() => (__webpack_require__(1005))))),
	2699: () => (loadSingletonVersion("default", "@design-system/icons/web-components/24x24/package-big-icon", false, [4,29,3,1], () => (__webpack_require__.e(4888).then(() => (() => (__webpack_require__(4888))))))),
	5435: () => (loadSingletonVersion("default", "vue-router", true, [1,4,5,0], () => (() => (__webpack_require__(9509))))),
	8836: () => (loadSingletonVersion("default", "element-plus", false, [1,2,13,7], () => (Promise.all([__webpack_require__.e(1605), __webpack_require__.e(3037), __webpack_require__.e(3199)]).then(() => (() => (__webpack_require__(1605))))))),
	1171: () => (loadSingletonVersion("default", "@design-system/icons/web-components/24x24/incidents-icon", false, [4,29,3,1], () => (__webpack_require__.e(6411).then(() => (() => (__webpack_require__(8792))))))),
	1325: () => (loadSingletonVersion("default", "@design-system/illustrations/web-components/medium/package-empty-illustration", false, [4,29,3,1], () => (__webpack_require__.e(7448).then(() => (() => (__webpack_require__(7448))))))),
	1831: () => (loadSingletonVersion("default", "@design-system/web-components/illustration", false, [4,29,3,1], () => (__webpack_require__.e(9545).then(() => (() => (__webpack_require__(9545))))))),
	2057: () => (loadSingletonVersion("default", "@design-system/icons/web-components/24x24/download-icon", false, [4,29,3,1], () => (__webpack_require__.e(8145).then(() => (() => (__webpack_require__(8145))))))),
	2753: () => (loadSingletonVersion("default", "@design-system/icons/web-components/24x24/info-icon", false, [4,29,3,1], () => (__webpack_require__.e(1589).then(() => (() => (__webpack_require__(1589))))))),
	8007: () => (loadSingletonVersion("default", "@design-system/icons/web-components/24x24/time-icon", false, [4,29,3,1], () => (__webpack_require__.e(7294).then(() => (() => (__webpack_require__(7294))))))),
	8055: () => (loadSingletonVersion("default", "@design-system/icons/web-components/24x24/in-progress-icon", false, [4,29,3,1], () => (__webpack_require__.e(6182).then(() => (() => (__webpack_require__(6182))))))),
	9130: () => (loadSingletonVersion("default", "@mcp/frontend-common", false, [0], () => (Promise.all([__webpack_require__.e(7663), __webpack_require__.e(8560), __webpack_require__.e(5141), __webpack_require__.e(1919), __webpack_require__.e(3565), __webpack_require__.e(6041)]).then(() => (() => (__webpack_require__(6041))))))),
	887: () => (loadSingletonVersion("default", "@design-system/icons/web-components/24x24/copy-icon", false, [4,29,3,1], () => (__webpack_require__.e(7722).then(() => (() => (__webpack_require__(7722))))))),
	1315: () => (loadSingletonVersion("default", "@design-system/icons/web-components/24x24/edit-b-icon", false, [4,29,3,1], () => (__webpack_require__.e(6516).then(() => (() => (__webpack_require__(6516))))))),
	1769: () => (loadSingletonVersion("default", "@design-system/icons/web-components/24x24/conditions-icon", false, [4,29,3,1], () => (__webpack_require__.e(1791).then(() => (() => (__webpack_require__(1791))))))),
	2901: () => (loadSingletonVersion("default", "@design-system/icons/web-components/24x24/plus-icon", false, [4,29,3,1], () => (__webpack_require__.e(9081).then(() => (() => (__webpack_require__(9081))))))),
	3899: () => (loadSingletonVersion("default", "@design-system/icons/web-components/24x24/time-back-icon", false, [4,29,3,1], () => (__webpack_require__.e(5040).then(() => (() => (__webpack_require__(5040))))))),
	4033: () => (loadSingletonVersion("default", "@design-system/icons/web-components/24x24/bulk-combination-icon", false, [4,29,3,1], () => (__webpack_require__.e(8135).then(() => (() => (__webpack_require__(8135))))))),
	4243: () => (loadSingletonVersion("default", "@design-system/icons/web-components/24x24/information-icon", false, [4,29,3,1], () => (__webpack_require__.e(8867).then(() => (() => (__webpack_require__(8867))))))),
	5163: () => (loadSingletonVersion("default", "@design-system/icons/web-components/24x24/location-icon", false, [4,29,3,1], () => (__webpack_require__.e(80).then(() => (() => (__webpack_require__(80))))))),
	6419: () => (loadSingletonVersion("default", "@design-system/icons/web-components/24x24/delete-icon", false, [4,29,3,1], () => (__webpack_require__.e(5524).then(() => (() => (__webpack_require__(5524))))))),
	6461: () => (loadSingletonVersion("default", "@design-system/illustrations/web-components/basic/package-cat-plant-illustration", false, [4,29,3,1], () => (__webpack_require__.e(720).then(() => (() => (__webpack_require__(720))))))),
	6597: () => (loadSingletonVersion("default", "@design-system/illustrations/web-components/basic/bulk-packages-b-illustration", false, [4,29,3,1], () => (__webpack_require__.e(1756).then(() => (() => (__webpack_require__(1756))))))),
	6861: () => (loadSingletonVersion("default", "@design-system/illustrations/web-components/basic/package-install-illustration", false, [4,29,3,1], () => (__webpack_require__.e(5529).then(() => (() => (__webpack_require__(5529))))))),
	7861: () => (loadSingletonVersion("default", "@design-system/illustrations/web-components/medium/cat-in-box-illustration", false, [4,29,3,1], () => (__webpack_require__.e(8404).then(() => (() => (__webpack_require__(8404))))))),
	9218: () => (loadSingleton("default", "@dsc/components", false, () => (Promise.all([__webpack_require__.e(7663), __webpack_require__.e(6200), __webpack_require__.e(822), __webpack_require__.e(1919), __webpack_require__.e(6897), __webpack_require__.e(3037), __webpack_require__.e(4414), __webpack_require__.e(9825)]).then(() => (() => (__webpack_require__(9825))))))),
	3687: () => (loadSingletonVersion("default", "vue", true, [1,3,5,13], () => (() => (__webpack_require__(8857))))),
	9513: () => (loadSingletonVersion("default", "vue", true, [1,3,5,13], () => (() => (__webpack_require__(8727))))),
	6024: () => (loadSingletonVersion("default", "vue-router", true, [4,4,5,0], () => (() => (__webpack_require__(9509))))),
	3255: () => (loadSingletonVersion("default", "@design-system/icons/web-components/24x24/cargo-icon", false, [4,29,3,1], () => (__webpack_require__.e(9509).then(() => (() => (__webpack_require__(1890)))))))
};
const initialConsumes = [5194,8328];
initialConsumes.forEach((id) => {
	__webpack_require__.m[id] = (module) => {
		// Handle case when module is used sync
		installedModules[id] = 0;
		delete __webpack_require__.c[id];
		const factory = moduleToHandlerMapping[id]();
		if(typeof factory !== "function") throw new Error("Shared module is not available for eager consumption: " + id);
		module.exports = factory();
	}
});
const chunkMapping = {
	"223": [
		887,
		1315,
		1769,
		2901,
		3899,
		4033,
		4243,
		5163,
		6419,
		6461,
		6597,
		6861,
		7861,
		9218
	],
	"703": [
		703
	],
	"822": [
		822
	],
	"1919": [
		791,
		1841,
		1875,
		3629,
		3685,
		5073,
		6663,
		6799,
		7031,
		9487,
		9847
	],
	"3037": [
		3037
	],
	"3199": [
		3687,
		9513
	],
	"3362": [
		3255
	],
	"3565": [
		2578,
		2699,
		5435,
		8836
	],
	"4414": [
		4414
	],
	"4505": [
		4505
	],
	"6024": [
		6024
	],
	"6041": [
		1171,
		1325,
		1831,
		2057,
		2753,
		8007,
		8055
	],
	"6897": [
		6897
	],
	"8533": [
		3602,
		5198,
		5314
	],
	"8560": [
		2432,
		6423
	],
	"8792": [
		5194,
		8328
	],
	"9130": [
		9130
	],
	"9825": [
		2265
	]
};
const startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			const onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			const onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				const promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}